<mat-card
    class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
                       placeholder="Chercher un Emplacement..."
                       (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <button class="btn btn-primary btn-sm rounded-start-pill" (click)="openModal(content)">
                <span class="px-2">Nouveau</span>
            </button>
            <button class="btn btn-outline-primary btn-sm rounded-end-pill" [matMenuTriggerFor]="menu"
                    aria-haspopup="true" aria-expanded="false" id="dropdownMenuClickableInside">
                <i class="fa-solid fa-table px-3"></i>
            </button>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>
                    <!-- Name Column -->
                    <ng-container matColumnDef="nom">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nom</th>
                        <td mat-cell *matCellDef="let element"> {{ element.nom }}</td>
                    </ng-container>
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Description</th>
                        <td mat-cell *matCellDef="let element"> {{ element.description }}</td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Actions</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center" style="justify-content: center !important;">
                                <button type="button" mat-button matTooltip="Visualiser" matTooltipPosition="above"
                                        (click)="openViewModel(element)">
                                    <i class="material-symbols-outlined">
                                        visibility
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above"
                                        (click)="openEditModal(element)">
                                    <i class="material-symbols-outlined text-primary">
                                        brush
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                        (click)="confirmDelete(element)">
                                    <i class="material-symbols-outlined text-danger">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="getdisplayedCol()"></tr>
                    <tr mat-row *matRowDef="let row; columns: getdisplayedCol();"></tr>

                    <div *ngIf="!loadingTable">
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="15">Aucun résultat trouvé pour "{{ input.value }}"</td>
                        </tr>
                    </div>

                </table>

                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>


</mat-card>


<!-- Add modal template for editing -->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Modifier Fournisseur
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="editForm" (ngSubmit)="updateEmplacement()">
                <div class="row">
                    <!-- Form fields here -->
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Nom</mat-label>
                            <input matInput formControlName="nom" placeholder="Ex. Frigo,Armoire">
                            <mat-error *ngIf="editForm.get('nom')?.hasError('required')">Le nom est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12">
                        <mat-form-field class="mb-25">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description" placeholder="Ex. Description..."></textarea>
                            <mat-error *ngIf="editForm.get('description')?.hasError('required')">La description est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 text-right">
                        <button type="submit" class="btn btn-primary btn-sm">Sauvegarder</button>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>

<ng-template #viewModal let-modal >
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-content>
            <div class="row">
                <h5 class="px-3 fw-bold">Détails d'emplacement :</h5>

                <!-- Name and First Name -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Nom :</div>
                    <p>{{ empl?.nom }}</p>
                </div>
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Description :</div>
                    <p>{{ empl?.description }}</p>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</ng-template>

<ng-template #content let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Nouveau Emplacemnt
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="saveEmplacement()">
                <div class="row">
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Nom</mat-label>
                            <input matInput formControlName="nom" placeholder="Ex. Frigo,Armoire">
                            <mat-error *ngIf="form.get('nom')?.hasError('required')">Le nom est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Description</mat-label>
                            <input type="texterea" matInput formControlName="description" placeholder="Ex. Description ...">
                            <mat-error *ngIf="form.get('description')?.hasError('required')">La description est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 text-right">
                        <button type="submit" class="btn btn-success btn-sm" [disabled]="form.invalid">Sauvegarder</button>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>


<!-- Menu with Checkboxes -->
<mat-menu #menu="matMenu">
    <div class="scrollable-menu shadow-lg bg-body">
        <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                      (click)="$event.stopPropagation()">Tous
        </mat-checkbox>
        @for (col of columns; track $index) {
            <div>
                <mat-checkbox [value]="col"
                              [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                              (click)="$event.stopPropagation(); onSelectionChange(col)">
                    {{ col }}
                </mat-checkbox>
            </div>
        }
    </div>

</mat-menu>
